// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2b6a3","buttons":"RemoveExpirationActionButtons_buttons__2Tv_w"};